import React from 'react';

const RenderPermissionByDevice = () => {
	return <div>RenderPermissionByDevice</div>;
};

export default RenderPermissionByDevice;
